export default __webpack_public_path__ + "static/media/logo-app2h.c0cdf4cf.svg";